import { render } from "./BaseInvoiceRow.vue?vue&type=template&id=4b2e99a5&scoped=true"
import script from "./BaseInvoiceRow.vue?vue&type=script&lang=js"
export * from "./BaseInvoiceRow.vue?vue&type=script&lang=js"

import "./BaseInvoiceRow.vue?vue&type=style&index=0&id=4b2e99a5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b2e99a5"
/* hot reload */
if (module.hot) {
  script.__hmrId = "4b2e99a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b2e99a5', script)) {
    api.reload('4b2e99a5', script)
  }
  
  module.hot.accept("./BaseInvoiceRow.vue?vue&type=template&id=4b2e99a5&scoped=true", () => {
    api.rerender('4b2e99a5', render)
  })

}

script.__file = "src/ui/invoices/BaseInvoiceRow.vue"

export default script